import ServicePage from './page';
import { retirementPlanningData } from '@/mocks/servicePagesBatch2';

export default function RetirementPlanningPage() {
  return <ServicePage data={retirementPlanningData} />;
}